import React, { useState } from "react";

import Button from "../../atoms/button/button";

import "./conversationBottom.scss";

interface ConversationBottomInterface {
  liked: boolean;
  makeLike: () => any;
  onClickBtn: () => any;
  shareAction: () => any;
  title: string;
}

const ConversationBottom = (props: ConversationBottomInterface) => {
  const { liked, makeLike, onClickBtn, shareAction, title } = props;

  const [toggleOption, setToggleOption] = useState(false);

  const toggleOptions = (event) => {
    const { id } = event.target;

    if (id === "container" || id === "") setToggleOption(false);
    else if (id === "modal-container") setToggleOption(!toggleOption);
    else if (id === "modal-dots") setToggleOption(!toggleOption);
    else if (id === "modal") setToggleOption(false);
  };

  return (
    <div
      className="a-conversation-bottom"
      id="container"
      onClick={toggleOptions}
    >
      <div className="a-conversation-bottom__title">
        <p>{title}</p>
      </div>

      <div className="a-conversation-bottom__interactive">
        <Button
          classname="a-conversation-bottom__interactive-btn"
          type="button"
          text="COMENTAR"
          isDisabled={false}
          onClickAction={onClickBtn}
        />
      </div>

      <div
        className="a-conversation-bottom__options"
        id="modal-container"
        onClick={toggleOptions}
      >
        <p className="icon-ellipsis-v" id="modal-dots"></p>

        {toggleOption ? (
          <div
            className="a-conversation-bottom__options-modal"
            id="modal"
            onClick={toggleOptions}
          >
            <i
              className={`a-conversation-bottom__options-like 
                ${!liked ? "icon-heart1" : "icon-heart"}`}
              onClick={makeLike}
            ></i>

            <i
              className="a-conversation-bottom__options-share icon-share"
              onClick={shareAction}
            ></i>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ConversationBottom;
